var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed w-full full-page bg-white"},[_c('div',{staticClass:"fixed w-full top-0 top-stripe"}),_c('div',{staticClass:"transition-all duration-400 h-full mt-2",class:{ 'pb-48 s:pb-16': _vm.isCookiesConsentShowing }},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }